import { request } from '../../helpers/axios'

export const actions = {

  async getAll() {
    const { chapters } = await request.$get(`/GuideLibrary/chapters`)
    return chapters
  },
  async createChapter() {
    const { chapter } = await request.$post(`/admin/GuideLibrary/chapters`)
    return chapter
  },
  async editChapter(_, { chapterId, title }) {
    await request.$patch(`/admin/GuideLibrary/chapters/${chapterId}`, { title })
  },
  async deleteChapter(_, { chapterId }) {
    await request.$delete(`/admin/GuideLibrary/chapters/${chapterId}`)
  },
  async orderChapters(_, { chaptersId }) {
    await request.$patch(`/admin/GuideLibrary/chapters/order`, { orderedChaptersIds: chaptersId })
  },
  async createGuide(_, { chapterId }) {
    const { guide } = await request.$post(`/admin/GuideLibrary/chapters/${chapterId}`)
    return guide
  },
  async editGuide(_, { chapterId, guideId, fields }) {
    await request.$patch(`/admin/GuideLibrary/chapters/${chapterId}/guides/${guideId}`, fields)
  },
  async deleteGuide(_, { chapterId, guideId }) {
    await request.$delete(`/admin/GuideLibrary/chapters/${chapterId}/guides/${guideId}`)
  },
  async orderGuides(_, { chapterId, guidesId }) {
    await request.$patch(`/admin/GuideLibrary/chapters/${chapterId}/guides/order`, { orderedGuidesIds: guidesId })
  },

}
